module.exports = __webpack_public_path__ + "img/book7.e2366fdf.jpg";